module.exports = __webpack_public_path__ + "assets/images/prereq-plus-icon.73e4d4d990e357ec0fb54483701c6a20.svg";